import { ShaderMaterial } from 'three';

import { materialEasyUniforms, simpleFs, simpleVs } from '@resn/gozer-three';

class CustomMaterial extends ShaderMaterial {
    options = {
        name: 'CustomMaterial',
        transparent: true,
    };

    constructor({ uniforms = {}, vs = simpleVs, fs = simpleFs, options = {} } = {}) {
        Object.keys(uniforms).forEach((key) => {
            let value = uniforms[key];

            if (
                value &&
                typeof value === 'object' &&
                Object.prototype.hasOwnProperty.call(value, 'value')
            ) {
                uniforms[key] = value;
            } else {
                uniforms[key] = { value };
            }
        });

        super({
            uniforms,
            vertexShader: vs,
            fragmentShader: fs,
        });

        this.options = { ...this.options, ...options };

        this.type = this.options.name;
        this.extensions.derivatives = true;

        Object.keys(this.options).forEach((key) => (this[key] = this.options[key]));

        materialEasyUniforms(this);
    }
}

export default CustomMaterial;
